import AniBops from '../../assets/ani-bops.png';
import ReactMovies from '../../assets/react-movies.png';
import Blackjack from '../../assets/blackjack.png';
import MegaWar from '../../assets/mega_war.png';
export const ProjectData = [
	{
		id: 1,
		title: 'Ani-Bops',
		about:
			'A web application that allows users to find their favorite anime song just by searching the anime title.',
		tags: ['HTML/CSS', 'JavaScript', 'php', 'SQL'],
		demo: 'https://ani-bops.herokuapp.com/',
		github: 'https://github.com/matthewhirai/AniBops',
		image: AniBops
	},
	{
		id: 2,
		title: 'React-Movies',
		about:
			'A web application that allows users to search for their favorite movie, get info about it, and even rate it.',
		tags: ['React'],
		demo: 'https://tmdb-react-movies.netlify.app/',
		github: 'https://github.com/matthewhirai/react-movies',
		image: ReactMovies
	},
	{
		id: 3,
		title: 'Blackjack',
		about: 'Object oriented version of the card game Blackjack',
		tags: ['Python'],
		github: 'https://github.com/matthewhirai/Blackjack',
		image: Blackjack
	},
	{
		id: 4,
		title: 'Mega War',
		about:
			'An altered version of the card game "War" made in C++ where the user can choose as many decks and players to play the game.',
		tags: ['C++'],
		github: 'https://github.com/matthewhirai/Mega-War',
		image: MegaWar
	}
];
